// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3IqRu","comment":"styles_comment__x-B8q"};